import { FormControl, SxProps, Theme, Typography } from '@mui/material';

import { BackrsFormField } from './types';

type LeftAlignedLabelWrapperProps = Readonly<{
  field: BackrsFormField;
  error: boolean;
  isDisabled: boolean;
  children: React.ReactNode;
  index: number;
  groupedFields: Record<string, BackrsFormField[]>;
}>;

export const LeftAlignedLabelWrapper = ({
  field,
  error,
  isDisabled,
  children,
  groupedFields,
  index,
}: LeftAlignedLabelWrapperProps) => {
  return (
    <FormControl
      fullWidth
      error={!!error}
      disabled={field.disabled || isDisabled}
      sx={leftLabelTextFieldStyle(
        index === Object.entries(groupedFields).length - 1,
        field.divider || false,
      )}
    >
      <Typography variant="text-sm-medium" sx={leftLabelSx}>
        {field.label}
      </Typography>
      {children}
    </FormControl>
  );
};

const leftLabelTextFieldStyle =
  (isLastItem: boolean, divider: boolean): SxProps<Theme> =>
  ({ backrs }) => ({
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'flex-start',
    gap: { xs: backrs.spacing['spacing-md'], sm: backrs.spacing['spacing-2xl'] },
    height: 'fit-content',
    boxSizing: 'border-box',
    width: '100%',
    mb: {
      xs: backrs.spacing['spacing-md'],
      sm: backrs.spacing[isLastItem ? 'spacing-md' : 'spacing-2xl'],
    },
    ...(divider && {
      mb: backrs.spacing['spacing-none'],
    }),
    '& .MuiInputBase-adornedStart': {
      paddingY: `${backrs.spacing['spacing-none']} !important`,
    },

    '& input[type="date"]::-webkit-calendar-picker-indicator': {
      opacity: 0.0000001, // Hide visually, but keep it clickable
      position: 'absolute',
      right: '-16px',
      width: '100%',
      cursor: 'pointer',
      zIndex: 1000,
    },
  });

const leftLabelSx: SxProps<Theme> = ({ backrs }) => ({
  minWidth: '25%',
  color: backrs.colors['Colors/Text/text-primary'],
});
